var _style, _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgKrypcoresemilogo(_ref, svgRef) {
  let title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 512 512",
    style: {
      enableBackground: "new 0 0 512 512"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _style || (_style = /*#__PURE__*/React.createElement("style", {
    type: "text/css"
  }, "\r\n\t.st0{fill:url(#SVGID_1_);}\r\n")), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_1_",
    gradientUnits: "userSpaceOnUse",
    x1: 154.1519,
    y1: 432.406,
    x2: 357.8481,
    y2: 79.594
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.1711,
    style: {
      stopColor: "#4C59E3"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.1822,
    style: {
      stopColor: "#5453DF"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.2289,
    style: {
      stopColor: "#703ED3"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.2791,
    style: {
      stopColor: "#862EC9"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.3338,
    style: {
      stopColor: "#9622C1"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.3965,
    style: {
      stopColor: "#9F1BBD"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.4846,
    style: {
      stopColor: "#A219BC"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.6021,
    style: {
      stopColor: "#C11B93"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.8201,
    style: {
      stopColor: "#F81F49"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.8472,
    style: {
      stopColor: "#F92D41"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.899,
    style: {
      stopColor: "#F94135"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9503,
    style: {
      stopColor: "#FA4E2D"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#FA522B"
    }
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M497.7,256C497.7,256,497.7,256,497.7,256C497.7,256,497.7,256,497.7,256c-1.9,0.4-13.1,2.9-19.8,5.7 c-7.7,4.2-14,10.1-18.1,18.1c-0.2,0.4-0.7,1.1-1.3,1.8c-0.4,0.8-0.8,1.6-1.2,2.4c-5.4,11.3-11,22.5-16.5,33.7 c-7.5,15.4-15.1,30.9-22.6,46.3c-5.9,12.1-11.4,24.4-17.8,36.2c-6.2,11.4-15.9,18.7-28.6,22c-5.2,1.4-10.4,1.4-15.6,1.4 c-5.4,0-10.8,0-16.2,0c-0.7,0-1.4,0-2.1,0c-5.5,0-11,0-16.5,0l-27.6,0v0l-18.3,0v-2l8.5-0.9c13-2.8,21.5-12.1,27.6-24.3 c9.7-19.4,19-38.9,28.5-58.4c6.4-13.2,12.9-26.3,19.3-39.4c3.2-6.5,6.1-13.2,9.6-19.5c4.5-8.2,11-14.6,19.7-18.3 c4.3-1.9,8.8-3.4,13-4.8c-4.2-1.5-8.7-3-13-4.8c-8.7-3.8-15.2-10.1-19.7-18.3c-3.5-6.3-6.4-13-9.6-19.5 c-6.4-13.1-12.9-26.3-19.3-39.4c-9.5-19.5-18.8-39-28.5-58.4c-6.2-12.3-14.7-21.5-27.6-24.3l-8.5-0.9v-2l18.3,0v0l27.7,0 c5.5,0,11,0,16.4,0c0.7,0,1.4,0,2.1,0c5.4,0,10.8,0,16.2,0c5.3,0,10.4,0.1,15.6,1.4c12.7,3.3,22.4,10.7,28.6,22 c6.4,11.8,11.9,24.1,17.8,36.2c7.5,15.4,15,30.9,22.6,46.3c5.5,11.2,11.1,22.4,16.5,33.7c4,8.4,9.3,15.5,17.1,20.6 C479.7,252,495.5,255.5,497.7,256C497.7,256,497.7,256,497.7,256C497.7,256,497.7,256,497.7,256z M143,232.8 c3.5-6.3,6.4-13,9.6-19.5c6.4-13.1,12.9-26.3,19.3-39.4c9.5-19.5,18.8-39,28.5-58.4c6.2-12.3,14.7-21.5,27.6-24.3l8.5-0.9v-2 l-18.3,0v0l-27.7,0c-5.5,0-11,0-16.4,0c-0.7,0-1.4,0-2.1,0c-5.4,0-10.8,0-16.2,0c-5.3,0-10.4,0.1-15.6,1.4 c-12.7,3.3-22.4,10.7-28.6,22c-6.4,11.8-11.9,24.1-17.8,36.2c-7.5,15.4-15,30.9-22.6,46.3c-5.5,11.2-11.1,22.4-16.5,33.7 c-4,8.4-9.3,15.5-17.1,20.6c-5.3,3.4-21,7-23.2,7.5c0,0-0.1,0-0.1,0c0,0,0,0,0,0c0,0,0,0,0,0c0,0,0.1,0,0.1,0 c1.8,0.4,13,2.9,19.8,5.7c7.7,4.2,14,10.1,18.1,18.1c0.2,0.4,0.7,1.1,1.3,1.8c0.4,0.8,0.8,1.6,1.2,2.4c5.4,11.3,11,22.5,16.5,33.7 c7.5,15.4,15.1,30.9,22.6,46.3c5.9,12.1,11.4,24.4,17.8,36.2c6.2,11.4,15.9,18.7,28.6,22c5.2,1.4,10.4,1.4,15.6,1.4 c5.4,0,10.8,0,16.2,0c0.7,0,1.4,0,2.1,0c5.5,0,11,0,16.5,0l27.6,0v0l18.3,0v-2l-8.5-0.9c-13-2.8-21.5-12.1-27.6-24.3 c-9.7-19.4-19-38.9-28.5-58.4c-6.4-13.2-12.9-26.3-19.3-39.4c-3.2-6.5-6.1-13.2-9.6-19.5c-4.5-8.2-11-14.6-19.7-18.3 c-4.3-1.9-8.8-3.4-13-4.8c4.2-1.5,8.7-3,13-4.8C132,247.4,138.5,241,143,232.8z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgKrypcoresemilogo);
export default __webpack_public_path__ + "static/media/krypcoresemilogo.521fb8c22a929e992a0e40ea8eba9643.svg";
export { ForwardRef as ReactComponent };